var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FileItem, FileName, FileNameContainer, FileDeleteIcon, GFXIcon, Image, IconContainer, FileDeleteIconContainer, ImageContainer, UplodOnProgressBg, } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import { faFilePdf } from '@fortawesome/pro-solid-svg-icons/faFilePdf';
export var SingleFile = function (props) {
    var isUploading = props.file.isUploading;
    var renderDelete = function () {
        return props.deleteFileOnProgress &&
            props.deleteFileOnProgress.includes(props.file.id) ? (_jsx(FontAwesomeIcon, { icon: faSpinner, color: "#999", spin: true })) : (_jsx(FileDeleteIconContainer, __assign({ onClick: function (e) {
                e.stopPropagation();
                props.onDeleteConfirmation(true);
                props.onSelectFile(props.file.id);
            } }, { children: _jsx(FileDeleteIcon, {}) })));
    };
    return (_jsxs(FileItem, __assign({ isMediaModal: props.isMediaModal, isLastImageInRow: props.isLastImageInRow, onClick: props.onClick }, { children: [props.file.gfx_data && _jsx(GFXIcon, { children: "GFX" }), props.file.mime_type === 'application/pdf' ? (_jsx(IconContainer, __assign({ pdf: true, onClick: function () {
                    return !props.isMediaModal && props.openPDF && props.openPDF(props.file);
                } }, { children: _jsx(FontAwesomeIcon, { icon: faFilePdf }) }))) : (_jsx(ImageContainer, { children: _jsx(Image, { src: props.file.isUploading
                        ? props.file.url
                        : props.file.mime_type === 'image/svg+xml'
                            ? "".concat(props.getFileBucket(props.file.mime_type), "/").concat(props.file.external_id).concat(props.isMediaModal ? '?h=200&w=200' : '?h=300&w=300')
                            : "".concat(props.getFileBucket(props.file.mime_type), "/").concat(props.file.external_id).concat(props.isMediaModal ? '?h=200&w=200' : '?h=300&w=300'), isMediaModal: props.isMediaModal, crossOrigin: "anonymous", alt: props.file.name, onClick: function () {
                        return !props.isMediaModal &&
                            props.showImgModal &&
                            props.showImgModal(props.file);
                    } }) })), _jsxs(FileNameContainer, { children: [_jsx(FileName, { children: props.file.name.length > 30
                            ? "".concat(props.file.name.slice(0, 22), "...").concat(props.file.name.substr(props.file.name.length - 5))
                            : props.file.name }), !isUploading &&
                        (props.PermissionsWrapper ? (_jsx(props.PermissionsWrapper, __assign({ target: props.target, action: "delete" }, { children: renderDelete() }))) : (renderDelete()))] }), isUploading && (_jsx(UplodOnProgressBg, { children: _jsx(FontAwesomeIcon, { icon: faSpinner, color: "#fff", spin: true, size: "2x" }) }))] })));
};
